var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFileVideoRecord(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2695",
    d: "M0-682.665H14v14H0Z",
    transform: "translate(0 682.665)"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_43223",
    "data-name": "Group 43223",
    transform: "translate(-10915 -13899)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_16052",
    "data-name": "Rectangle 16052",
    width: 16,
    height: 16,
    transform: "translate(10915 13899)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "g2685",
    transform: "translate(10916 14582.665)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g2691",
    transform: "translate(0 -682.665)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g2693",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g2699",
    transform: "translate(0.41 2.078)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2701",
    d: "M-629.485-391.8a1.641,1.641,0,0,1-1.641,1.641h-9.9a1.641,1.641,0,0,1-1.641-1.641v-6.562A1.641,1.641,0,0,1-641.024-400h9.9a1.641,1.641,0,0,1,1.641,1.641Z",
    transform: "translate(642.665 399.999)",
    fill: "#1564e8"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "g2687",
    transform: "translate(5.359 -677.716)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2689",
    d: "M-156.718-97.949-160-95.9V-100Z",
    transform: "translate(160 100)",
    fill: "#fff"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileVideoRecord);
export default __webpack_public_path__ + "static/media/file-video-record.417952ffd177ec27825739d618ac73a4.svg";
export { ForwardRef as ReactComponent };